import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import Loading from 'shared/components/Loading/Loading';
import { ConfigurationPath } from './router';

const Roles = lazy(() => import('./pages/Roles/Roles'));
const Modules = lazy(() => import('./pages/Modules/Modules'));
const Menus = lazy(() => import('./pages/Menus/Menus'));
const Access = lazy(() => import('./pages/Access/Access'));
const User = lazy(() => import('./pages/User/User'));
const Profile = lazy(() => import('./pages/Profile/Profile'));
const Companies = lazy(() => import('./pages/Company/Company'));
const BranchOffice = lazy(() => import('./pages/BranchOffice/BranchOffices'));
const CashRegister = lazy(() => import('./pages/CashRegister/CashRegister'));
const SerialVoucher = lazy(() => import('./pages/SerialVoucher/SerialVoucher'));
const CategoryMovement = lazy(() => import('./pages/CategoryMovement/CategoryMovement'));
const Contacts = lazy(() => import('./pages/Contacts/Contacts'));

export const ConfigurationRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense fallback={<Loading show />}>
      <Routes>
        <Route path={ConfigurationPath.Rol} element={<Roles />} />
        <Route path={ConfigurationPath.Module} element={<Modules />} />
        <Route path={ConfigurationPath.Menu} element={<Menus />} />
        <Route path={ConfigurationPath.Access} element={<Access />} />
        <Route path={ConfigurationPath.User} element={<User />} />
        <Route path={ConfigurationPath.Profile} element={<Profile />} />
        <Route path={ConfigurationPath.Company} element={<Companies />} />
        <Route path={ConfigurationPath.BranchOffice} element={<BranchOffice />} />
        <Route path={ConfigurationPath.CashRegister} element={<CashRegister />} />
        <Route path={ConfigurationPath.SerialVoucher} element={<SerialVoucher />} />
        <Route path={ConfigurationPath.CategoryMovement} element={<CategoryMovement />} />
        <Route path={ConfigurationPath.Contacts} element={<Contacts />} />
        <Route path="*" element={<Redirect to={ConfigurationPath.Rol} replace />} />
      </Routes>
    </Suspense>
  );
};

export const ConfigurationRouter: React.FC = () => <ConfigurationRoutes />;
